import { render, staticRenderFns } from "./videoDoctor.vue?vue&type=template&id=d4e2edac&scoped=true&"
import script from "./videoDoctor.vue?vue&type=script&lang=js&"
export * from "./videoDoctor.vue?vue&type=script&lang=js&"
import style0 from "./videoDoctor.vue?vue&type=style&index=0&id=d4e2edac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e2edac",
  null
  
)

export default component.exports